import type { FaireProductEntity } from "../../entity_types/product";

export const p_7nx593237m: FaireProductEntity = {
  token: "p_7nx593237m",
  type: "product",
  name: "Plush Vetiver– HI-FI Reed Diffuser",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/1d9c63aadd2478bf513f25d15197a02f3b0217ad845e3cae78eab614f6ee47aa.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/56ce320a08b7157077dc256653de9f058423010d6066ad1f6cd476197dd747c6.jpeg",
    "https://cdn.faire.com/fastly/b4b59e1d98eb796c0ba5d0e77cf1776322e6b3afbf11111bcd00b191792ff7e9.jpeg",
    "https://cdn.faire.com/fastly/e4ef77169b9dcd818f35b3fc8a0198635d0be7b4ffbae33e16e77f6885694189.jpeg",
    "https://cdn.faire.com/fastly/fb6d549a6cc144d4e70615660a3fdcf8a0aad3b54f40b3fe7fde5d8b2ee10b28.jpeg",
    "https://cdn.faire.com/fastly/1869bdb5e4f8f91f588fb709c781af7097284dfca3b4a345e52fa33b78bfb1a3.jpeg",
  ],
  priceDollars: 19.5,
  description:
    '*Due to unexpected supply chain shifts, we are experiencing a gap in our production schedule. Sold out HI-FI products are expected to restock this Summer*\n\nPlush velvet and smooth banquettes in a dimly lit cocktail lounge. Musky, earthy, and soft with a velvety floral undertone.  Haitian vetiver, velvet iris, patchouli leaf, and beetroot.\n\nPRODUCT INFORMATION: \n\nEach diffuser contains a 4 fl oz blend of naturally-derived and man-made fragrance oils in a square custom cocoa brown glass bottle with a Vermilion debossed front label and packaged in a premium paper gift box.\n\nLasts approximately 3-4 months.\n\nIncludes a bundle of 9" long naturally-harvested black dyed rattan reeds to absorb and slowly release the fragrance.',
  tags: [],
  msrpDollars: 40,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-01T19:03:55.902Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
